import Twitter from "react-feather/dist/icons/twitter";
import Facebook from "react-feather/dist/icons/facebook";
import Instagram from "react-feather/dist/icons/instagram";
import { Link } from "react-router-dom";
import classnames from "classnames";

import style from "./style.module.scss";

interface FooterProps {
  className?: string;
}

function Footer({ className }: FooterProps) {
  return (
    <footer className={classnames(className, style.footer)}>
      <div className={style.links}>
        <Link to="/photo-book">Livre photo</Link>
        <Link to="/calendar">Calendrier</Link>
        <span className={style.separator} />
        <Link to="/about">À propos</Link>
        <Link to="/faq">Questions fréquentes</Link>
        <Link to="/privacy">Termes de confidentialité</Link>
      </div>
      <div className={style.social}>
        <a
          href="https://twitter.com/lymabook"
          target="_blank"
          rel="noopener noreferrer"
          title="Suivez Lymaprint sur Twitter"
        >
          <Twitter />
        </a>
        <a
          href="https://facebook.com/lymabook"
          target="_blank"
          rel="noopener noreferrer"
          title="Suivez Lymaprint sur Facebook"
        >
          <Facebook />
        </a>
        <a
          href="https://instagram.com/lymabook"
          target="_blank"
          rel="noopener noreferrer"
          title="Suivez Lymaprint sur Instagram"
        >
          <Instagram />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
